import { compose, withHandlers, pure, defaultProps } from "recompose";

import withStyles from "./styles";

export default compose(
  withStyles,
  pure,
  defaultProps({
    disableClick: false,
    name: "image",
    accept: "image/jpeg, image/png, image/svg+xml"
  }),
  withHandlers({
    onDrop: ({ onChangeImage, allowMultiple }) => pictures => {
      onChangeImage(allowMultiple ? pictures : pictures[0]);
    }
  })
);
